import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBanana = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "banana",
	"data-name": "banana",
	viewBox: "-6 -6 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M 8.3486029,11.700386 C 8.4720271,7.2025017 9.5519884,1.4999999 12.431885,1.4999999 c 2.51991,0 2.96218,5.0030467 3.085604,8.3351732",
			id: "path1",
			style: { strokeWidth: .999593 }
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 15.754052,14.878558 c 0.30856,2.201064 0.771401,4.340416 0.771401,5.656941 0,1.316524 0.236563,1.964501 -2.057069,1.964501 -1.697082,0 -4.8135421,-3.322167 -5.8112207,-7.302596",
			id: "path2",
			style: { strokeWidth: 1.02853 }
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 11.403351,12.728921 c 0,0 -3.0856041,0 -3.0856041,4.916395 0,4.916396 -2.1496374,1.748509 -3.0856039,0 -1.0285346,-1.964501 -1.0285346,-5.893503 2.0570692,-5.893503 3.0856038,0 4.1141388,0.977108 4.1141388,0.977108 z",
			id: "path3",
			style: { strokeWidth: 1.02853 }
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 11.403351,12.728921 c 0,0 2.818185,-1.429663 4.792971,3.085604 1.974786,4.515267 2.931324,0.730259 3.157601,-1.275383 0.267419,-2.23192 -1.316524,-5.8523621 -4.474125,-4.5872649 -3.157602,1.2650979 -3.476447,2.7770439 -3.476447,2.7770439 z",
			id: "path4",
			style: { strokeWidth: 1.02853 }
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 11.506204,12.728921 c 0,0 1.028535,3.929002 1.964501,4.916395",
			id: "path5",
			style: { strokeWidth: 1.02853 }
		})
	]
});
const ForwardRef = forwardRef(SvgBanana);
export default ForwardRef;
